import type { ApiResult } from '@/features/_lib/api/client'
import type { TPublicProblemDetails } from '@doutorsim/shared/problem-details'

export class ApiQueryError extends Error {
  public readonly apiError: TPublicProblemDetails

  constructor(apiError: TPublicProblemDetails) {
    super(apiError.detail ?? apiError.title)
    this.name = 'ApiQueryError'
    this.apiError = apiError
  }
}

export function unwrapApiResult<T>(result: ApiResult<T>): T {
  if (result.error) {
    throw new ApiQueryError(result.error)
  }

  return result.data
}
